import { HsVector3 } from '../../math-new/objects/vector3.class';
import type { HsParticle } from './particle.interface';

export abstract class HsForce {
  public direction: HsVector3 = HsVector3.makeUnitVectorX();

  static readonly #force: HsVector3 = HsVector3.makeZeroVector();

  constructor(public strength: number = 1) {}

  public getDirection(): HsVector3 {
    return this.direction;
  }

  public apply(particle: HsParticle, deltaTime: number): void {
    HsForce.#force.copy(this.getDirection());
    HsForce.#force.multiplyByScalar(this.strength * deltaTime);
    particle.acceleration.add(HsForce.#force);
  }
}
